import React, { useEffect, useState } from "react";
import { fetchUndecidedRequests } from "./service";
import toast from "react-hot-toast";
import Template from "../../components/template";
import CardWithHeaderTemplate from "../../components/cardWithHeaderTemplate";
import HeaderView from "./components/HeaderView";
import DivSpinner from "../../components/divSpinner";
import Table from "./components/Table";
import PaginationView from "./components/PaginationView";

// Moved outside to avoid re-declaring on every render
const Loading = () => (
    <div style={{ height: `${window.innerHeight - 387}px` }}>
        <DivSpinner />
    </div>
);

const Undecided = () => {
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [undecidedRequests, setUndecidedRequests] = useState({
        loading: true,
        totalPages: 0,
        data: null,
        error: null,
    });

    useEffect(() => {
        const getUndecidedRequests = async () => {
            setUndecidedRequests(prev => ({ ...prev, loading: true }));

            try {
                const response = await fetchUndecidedRequests(page, searchTerm);
                setUndecidedRequests({
                    loading: false,
                    data: response.jobs,
                    totalPages: response.total_pages,
                    error: null,
                });
            } catch (error) {
                toast.error(error.message || "Failed to fetch data");
                setUndecidedRequests(prev => ({ ...prev, loading: false, error: error.message }));
            }
        };

        getUndecidedRequests();
    }, [page, searchTerm]);

    return (
        <Template>
            <div className="container-fluid py-4">
                <div className="row">
                    <div className="col-12">
                        <CardWithHeaderTemplate
                            header={
                                <HeaderView
                                    onSearch={(text) => {
                                        setPage(1);           // Reset to first page
                                        setSearchTerm(text);  // Set search term
                                    }}
                                />
                            }
                            body={undecidedRequests.loading
                                ? <Loading />
                                : <Table jobs={undecidedRequests.data} />}
                            footer={
                                <PaginationView
                                    undecidedRequests={undecidedRequests}
                                    page={page}
                                    setPage={setPage}
                                />
                            }
                        />
                    </div>
                </div>
            </div>
        </Template>
    );
};

export default Undecided;